export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const SET_ONLY_CATEOGRY = 'SET_ONLY_CATEOGRY';
export const SET_ONLY_NOTIFICATION = 'SET_ONLY_NOTIFICATION';
export const REMOVE_ALL_NOTIFICATION = 'REMOVE_ALL_NOTIFICATION';
export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION';
